import ApiClient from '@config/network';
import { stripeAppearance } from '@config/theming';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { STRIPE_PAYMENT_TYPE } from '@types';
import { useEffect, useState } from 'react';

const useStripeOptions = (payment_types: STRIPE_PAYMENT_TYPE[]) => {
  const { checkout } = useCheckoutConfigContext();
  const [stripeOptions, setStripeOptions] = useState<StripeElementsOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    ApiClient.post<{ intent_id: string; client_secret: string }>(
      `rest/v1/checkout/stripe/${checkout.token}/payment-intent`,
      null,
      {
        params: {
          payment_types,
        },
      },
    )
      .then(({ data }) => {
        if (!data.client_secret) {
          setError('No client secret');
          return;
        }

        setStripeOptions({
          clientSecret: data.client_secret,
          appearance: stripeAppearance,
        });
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { stripeOptions, loading, error };
};

export default useStripeOptions;
